import { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

interface Provincia {
  codiceIstat: string | null;
  nome: string | null;
  sigla: string | null;
}

interface Comune {
  codiceIstatComuneAlfa: string | null;
  nomeIt: string | null;
  nomeItDe: string | null;
  nomeDe: string | null;
  cap: string | null;
  siglaProvincia: string | null;
  codiceIstatProvincia?: string | null; // Codice Istat della provincia
}

interface Frazione {
  id: number;
  comuneIstat: string;
  comune: string | null;
  provincia: string | null;
  frazione: string;
  seoString: string | null;
}

interface AddressResponse {
  province: Provincia[];
  comuni: Comune[];
  frazioni: Frazione[];
}

export const useGetAddresses = (agencyId: number) => {
  const [data, setData] = useState<AddressResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        setLoading(true);
        const response = await axios.post(`${API_BASE_URL}/province-comuni-agency`, { agencyId });
        setData(response.data);
      } catch (err: any) {
        setError('Errore durante il recupero degli indirizzi');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (agencyId) {
      fetchAddresses();
    }
  }, [agencyId]);

  return { data, loading, error };
};

export default useGetAddresses;
